import { useCallback } from 'react';

import { EOrderAsLastTimeState } from '@model';
import { useGetPreviousPageUrl } from '@services/routingService';

import { trackCartPageViewEvent, trackCheckoutCloseRepeatedPurchase } from '../../events';
import { IEcommerceCheckout } from '../../model';

/**
 * Custom hook for Checkout Close Repeated Purchase event that is used to manage GA feature switch
 * - In GA4 version trackCheckoutCloseRepeatedPurchase is being called
 */
export const useTrackCheckoutCloseRepeatedPurchase = () => {
  const previousPageUrl = useGetPreviousPageUrl();

  return useCallback(
    (checkout: IEcommerceCheckout, oaltState: EOrderAsLastTimeState) => {
      trackCheckoutCloseRepeatedPurchase(checkout, oaltState);
      trackCartPageViewEvent(previousPageUrl);
    },
    [previousPageUrl],
  );
};
